import api from './api'
import store from '@/store'
import authHeader from '@/services/auth-header';
import CallHelper from '@/helpers/call.helper'

class PaymentService {
    async get(userUuid, params = {}) {
        return CallHelper.getDataRecursive(
            '/user/' + userUuid + '/payment',
            params,
            (data, response) => {

                if(data['payments']) {
                    data['payments'] = [...data['payments'], ...response.data.payments]
                } else {
                    data['payments'] = response.data.payments
                }

                return data
            },
        )
    }

    async create(payment, userUuid) {
        return api.post('/user/' + userUuid + '/payment', payment)
        .then(response => response.data)
    }

    async cancel(paymentUuid, userUuid) {
        return api.patch('/user/' + userUuid + '/payment/' + paymentUuid + '/cancel')
        .then(response => response.data)
    }

    async getBalanceAccounts(userUuid) {
        return api.get('/user/' + userUuid + '/balance-accounts')
        .then(response => response.data)
    }

    calculateBalanceByAccounts(balance, accountsNumber, accountPrice = 5.0, months = 0, result = []) {
        if(accountsNumber == 0 || balance <= 0.0 || accountPrice <= 0.0) {
            return {
                accounts: 0,
                result: [],
            }
        }

        const cout = accountsNumber * accountPrice
        const currentMonths = Math.floor(balance / cout);

        const resultFromNext = this.calculateBalanceByAccounts(
            Math.max(balance - currentMonths * cout, 0.0),
            accountsNumber - 1,
            accountPrice,
            currentMonths + months,
            result
        )

        if(currentMonths != 0)
        {
            resultFromNext.result.push({
                months: currentMonths + months,
                accounts: accountsNumber - resultFromNext.accounts,
            })

            return {
                accounts: accountsNumber - resultFromNext.accounts,
                result: resultFromNext.result,
            }
        }

        return {
            accounts: resultFromNext.accounts,
            result: resultFromNext.result,
        }
    }

    async validate(token) {
        return api.get('/payment/token/' + token + '/validate')
    }
}

export default new PaymentService();
